module.exports = __webpack_public_path__ + "img/dzpdf7.42e34bb5.png";